(function () {
  var ROOT_SEL = '[data-geeko-vip-loyalty]';

  function initAnchorScroll(root) {
    root.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-vip-faq-item]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-vip-faq-trigger]');
      var panel = item.querySelector('[data-vip-faq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-vip-faq-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initSmilePanelCta(root, selector, deepLink, fallbackAttr, defaultFallback) {
    var btn = root.querySelector(selector);
    if (!btn) return;

    var fallbackUrl = root.getAttribute(fallbackAttr) || defaultFallback;

    function hasSmilePanelApi() {
      return (
        typeof window.SmileUI !== 'undefined' &&
        typeof window.SmileUI.openPanel === 'function'
      );
    }

    function openPanel() {
      if (!hasSmilePanelApi()) return false;
      try {
        var open = function () {
          window.SmileUI.openPanel({ deep_link: deepLink });
        };
        if (window.SmileUI.ready && typeof window.SmileUI.ready.then === 'function') {
          window.SmileUI.ready().then(open).catch(open);
        } else {
          open();
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    function waitAndOpen() {
      if (openPanel()) return;

      var settled = false;
      function settle() {
        if (settled) return;
        if (openPanel()) settled = true;
      }

      document.addEventListener('geeko-smile-ui-ready', settle, { once: true });
      document.addEventListener('smile-ui-loaded', settle, { once: true });

      var n = 0;
      var id = setInterval(function () {
        if (openPanel()) {
          settled = true;
          clearInterval(id);
        } else if (++n > 150) {
          clearInterval(id);
          if (!settled && fallbackUrl) {
            window.location.href = fallbackUrl;
          }
        }
      }, 100);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      waitAndOpen();
    });
  }

  function initSmileHeroCta(root) {
    initSmilePanelCta(
      root,
      '[data-vip-smile-home]',
      'home',
      'data-vip-hero-fallback-url',
      '#ways-to-earn'
    );
  }

  function initSmileEarnCta(root) {
    initSmilePanelCta(
      root,
      '[data-vip-smile-earn]',
      'points_activity_rules',
      'data-vip-earn-fallback-url',
      '#ways-to-earn'
    );
  }

  function initSmileRedeemCta(root) {
    initSmilePanelCta(
      root,
      '[data-vip-smile-redeem]',
      'points_products',
      'data-vip-redeem-fallback-url',
      '#ways-to-redeem'
    );
  }

  function initSmileReferCta(root) {
    initSmilePanelCta(
      root,
      '[data-vip-smile-refer]',
      'referral_program_details',
      'data-vip-refer-fallback-url',
      '#refer-a-friend'
    );
  }

  function initCarousel(wrap) {
    var track = wrap.querySelector('[data-vip-carousel-track]');
    var prevBtn = wrap.querySelector('[data-vip-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-vip-carousel-next]');
    var dotsContainer = wrap.querySelector('[data-vip-carousel-dots]');
    var viewport = wrap.querySelector('.geeko-vip-loyalty__carousel-viewport');
    var isRedeem = wrap.classList.contains('geeko-vip-loyalty__carousel--redeem');
    if (!track) return;

    var slides = track.querySelectorAll('[data-vip-carousel-slide]');
    if (!slides.length) return;

    var perView = parseInt(wrap.getAttribute('data-vip-carousel-per-view') || '1', 10);
    if (perView < 1) perView = 1;

    var index = 0;
    var maxIndex = Math.max(0, slides.length - perView);

    function getGap() {
      var style = window.getComputedStyle(track);
      return parseFloat(style.gap) || parseFloat(style.columnGap) || 12;
    }

    function getSlideStep() {
      var slide = slides[0];
      if (!slide) return 0;
      return slide.offsetWidth + getGap();
    }

    function syncViewportHeight() {
      if (!isRedeem || !viewport || !slides[index]) return;
      viewport.style.height = slides[index].offsetHeight + 'px';
    }

    function updateUI() {
      updateDots();
      updateArrows();
      syncViewportHeight();
    }

    function scrollToIndex(i) {
      index = Math.max(0, Math.min(i, maxIndex));
      var step = getSlideStep();
      track.scrollTo({ left: step * index, behavior: 'smooth' });
      updateUI();
    }

    function getIndexFromScroll() {
      var step = getSlideStep();
      if (!step) return 0;
      return Math.max(0, Math.min(Math.round(track.scrollLeft / step), maxIndex));
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('[data-vip-carousel-dot]');
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;
    }

    function onScroll() {
      index = getIndexFromScroll();
      updateUI();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(index + 1);
      });
    }

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        (function (dotIndex) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'geeko-vip-loyalty__carousel-dot';
          dot.setAttribute('data-vip-carousel-dot', '');
          dot.setAttribute('aria-label', 'Slide ' + (dotIndex + 1));
          dot.addEventListener('click', function () {
            scrollToIndex(dotIndex);
          });
          dotsContainer.appendChild(dot);
        })(i);
      }
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        maxIndex = Math.max(0, slides.length - perView);
        scrollToIndex(index);
      },
      { passive: true }
    );

    scrollToIndex(0);
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-vip-carousel]').forEach(initCarousel);
  }

  function init(root) {
    initAnchorScroll(root);
    initFaq(root);
    initSmileHeroCta(root);
    initSmileEarnCta(root);
    initSmileRedeemCta(root);
    initSmileReferCta(root);
    initCarousels(root);
  }

  function boot() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
